import { MAX_FILE_SIZE, MAX_FILE_SIZE_MB } from './constants'

/**
 * Validates a SOW file for allowed extension and size limit.
 * Returns an error message string, or null if the file is valid.
 */
export function validateSowFile(file) {
  const ext = file.name.split('.').pop().toLowerCase()
  if (!['docx', 'pdf'].includes(ext))
    return 'Please upload a .docx or .pdf file.'
  if (file.size > MAX_FILE_SIZE)
    return `File size exceeds the ${MAX_FILE_SIZE_MB} MB limit. Please upload a smaller file.`
  return null
}
